module.exports = __webpack_public_path__ + "img/2.cf1fa148.jpg";